<template>
  <!-- 服务条款 / 隐私政策 PDF 预览弹窗，登录页可额外展示「同意并继续」 -->
  <Teleport to="body">
    <div
      v-if="modelValue"
      class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
      @click="close"
    >
      <div
        class="w-full max-w-[760px] h-[90vh] flex flex-col bg-popover border border-border rounded-[14px] overflow-hidden shadow-2xl"
        @click.stop
      >
        <div class="flex items-center justify-between px-5 py-4 bg-muted/20 border-b border-border shrink-0">
          <h3 class="font-semibold text-foreground text-[16px]">{{ title }}</h3>
          <button
            type="button"
            class="w-8 h-8 flex items-center justify-center rounded-[8px] text-muted-foreground hover:text-foreground hover:bg-muted/40 transition-colors"
            @click="close"
          >
            <X :size="18" />
          </button>
        </div>
        <div class="flex-1 overflow-hidden pdf-wrapper" style="min-height: 0">
          <iframe :src="documentSrc" :title="title" class="w-full h-full border-0 bg-white" />
        </div>
        <div class="px-5 py-4 bg-muted/10 border-t border-border flex justify-end gap-3 shrink-0">
          <button
            type="button"
            class="px-4 h-[38px] rounded-[8px] border border-border text-foreground text-[14px] hover:bg-muted/40 transition-colors"
            @click="close"
          >
            关闭
          </button>
          <button
            v-if="showAgree"
            type="button"
            class="px-4 h-[38px] rounded-[8px] bg-[#8b5cf6] hover:bg-[#7c3aed] text-white text-[14px] transition-colors"
            @click="emit('agree')"
          >
            同意并继续
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { X } from "@lucide/vue";
import { SITE_PRIVACY_PDF, SITE_TERMS_PDF } from "@/constants/siteLegal";

/** 弹窗展示的协议类型：服务条款 / 隐私政策 */
export type PolicyDocumentType = "terms" | "privacy";

const props = withDefaults(
  defineProps<{
    /** 当前打开的协议类型；null 表示关闭 */
    modelValue: PolicyDocumentType | null;
    /** 是否显示「同意并继续」（登录页需要） */
    showAgree?: boolean;
  }>(),
  {
    showAgree: false,
  },
);

const emit = defineEmits<{
  /** 更新弹窗开关状态 */
  "update:modelValue": [value: PolicyDocumentType | null];
  /** 用户点击「同意并继续」 */
  agree: [];
}>();

/** 弹窗标题 */
const title = computed(() => (props.modelValue === "terms" ? "服务条款" : "隐私政策"));

/** 当前协议对应的 PDF 地址 */
const documentSrc = computed(() => {
  if (props.modelValue === "terms") return SITE_TERMS_PDF;
  if (props.modelValue === "privacy") return SITE_PRIVACY_PDF;
  return "";
});

/** 关闭弹窗 */
const close = () => {
  emit("update:modelValue", null);
};
</script>
